module.exports = __webpack_public_path__ + "static/media/screenshot-1.ba08d426.png";